export const BLOCKED_REVIEW_IDS: Set<string> = new Set([
  '945dc8a8-0bf0-4d3d-abe4-431b1484ccfd',
  'b8fc462a-3837-4066-9b88-80eb7c3a98cf',
  '16161c15-8559-4997-a140-b70946b9b1e0',
  '6c78562d-4094-4ec3-a8c9-f83ec7c4f432',
  '3ce39ae5-e5ed-493c-bac2-6046bd1f0b81',
  '29e4ac64-ae68-42d1-a71d-5dcfb1585771',
  'debe78f5-ca6f-4be4-9acd-6debf5e9f2dc',
])

export const MIN_RATING = 4.5
export const MAX_REVIEWS = 3
export const FIVE_STAR = 5
export const MIN_VOTES = 1
export const MAX_AGE_MONTHS = 12
